import CoinStackSvgIcon from '@/shared/icons/CoinStackSvgIcon';
import { HStack, Text, StackProps, Image } from '@chakra-ui/react';
import React, { FC } from 'react'
import { useTranslations } from "next-intl";

interface CashbackBadgeProps extends StackProps {
  amount: number;
}

const CashbackBadge: FC<CashbackBadgeProps> = ({ amount, ...props }) => {
  const t = useTranslations()
  return (
    <HStack h={"40px"} py={"6px"} px={"16px"} bg={"#1818CF1A"} gap={"10px"} {...props}>
      <Image src="/qr+.svg" w={"40px"} />
      <Text textStyle={{ base: "regular14" }} color={"accent"}>{t('cashback')} +{amount}%</Text>
    </HStack>
  )
}

export default CashbackBadge;